import { authenticatedFetch } from '../../../api/request';

export default async function getSecondarySpecialties(doctorId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener las especialidades secundarias de este perfil.');
    return await authenticatedFetch(`/doctor-profile-management/specialties-in-profile/${doctorId}`, onError);
}
